export default __webpack_public_path__ + "static/media/logo-drawer.acf31774.svg";